import { render, staticRenderFns } from "./WelcomeHeaderDirectChat.vue?vue&type=template&id=35c62bc7&"
import script from "./WelcomeHeaderDirectChat.vue?vue&type=script&lang=js&"
export * from "./WelcomeHeaderDirectChat.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeHeaderDirectChat.vue?vue&type=style&index=0&id=35c62bc7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports